import * as React from "react";
import { H2, Paragraph } from "../ui/typography";

interface SectionProps {
  title: string;
  children?: React.ReactNode;
  className?: string;
  description?: React.ReactNode;
  headerButton?: React.ReactNode;
}

export const Section = ({
  title,
  description,
  children,
  className,
  headerButton,
}: SectionProps): React.ReactElement => {
  return (
    <div className={`flex flex-col gap-2 ${className || ""}`}>
      <div className="flex flex-col">
        <div className="flex items-center justify-between border-b pb-2 mb-2">
          <H2>{title}</H2>
          {headerButton && <div className="flex-shrink-0">{headerButton}</div>}
        </div>
        {description && <Paragraph>{description}</Paragraph>}
      </div>
      {children}
    </div>
  );
};
